export default __webpack_public_path__ + "static/media/2@2x.83585d91.png";